import React, { useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  Grid,
  Typography
} from "@material-ui/core";

import InfoTooltip from "../../general/InfoTooltip";

export default function CreditPriceTableField(
	{
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
    showCurrency=true
	}) {

  const [value, setValue] = useState(null);

  useEffect(() => {
		const externalValue = 
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric===0
            ? currentMetafields[0].meta_value_numeric
            : ""
        ;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = 
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric===0
            ? currentMetafields[0].meta_value_numeric
            : ""
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);
  
	if (!fieldConfig )
		return null;	
	
  const helperText = hideChannels
			? null
			: ( currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")) );
	
  const inputProps = {};
		if (fieldConfig.character_limit && !isNaN(fieldConfig.character_limit))
			inputProps.maxLength = parseInt(fieldConfig.character_limit);
		if (fieldConfig.min && !isNaN(fieldConfig.min))
			inputProps.min = parseFloat(fieldConfig.min);
		if (fieldConfig.max && !isNaN(fieldConfig.max))
      inputProps.max = parseFloat(fieldConfig.max);
  
  return (
			<>
				<Grid item xs={7} md={9} >
					<Typography>
						{fieldConfig.label}
						{
							fieldConfig.description &&
							<InfoTooltip
								content={fieldConfig.description}
							/>
						}	
					</Typography>
					<Typography variant="caption" color="textSecondary">{helperText}</Typography>
				</Grid>
				<Grid item xs={5} md={3}>
					<TextField
						key={currentMetafields[0].id}
						fullWidth
						type="number"
						value={value||value===0 ? value : ""}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            onBlur={() => {
              // force rerender to make sure placeholders using the value of this field are updated
              setMetafieldsValues(currentMetafields, value, true);
            }}
						InputProps={{
							startAdornment: showCurrency ? <InputAdornment position="start">€</InputAdornment> : null,
						}}
						inputProps={{
							style:{textAlign:"right" }
						}}
					/>
				</Grid>
			</>
		);
}
